export { RequestCookies, ResponseCookies, stringifyCookie } from "next/dist/compiled/@edge-runtime/cookies";

//# sourceMappingURL=cookies.js.map